import React, { useState } from 'react';
import './game-settings.css';
import { Paragraph } from '../../../components/paragraph';
import { IconButton } from '../../../components/icon-button';
import { QUICKPLAY_SCREEN } from '../../../constants/routes';

const GameSettings = props => {
    const {
        shouldHideExitGame,
        exitGame,
        resumeGame,
        audio,
        setAudio,
        previousPage,
    } = props;

    const [exitGameConfirmation, setExitGameConfirmation] = useState(false);

    return (
        <>
            {exitGameConfirmation === true ? (
                <div className="game-settings__exit-game-confirmation">
                    <Paragraph
                        colorScheme="dark"
                        textAlign="center"
                        withSpacing={false}
                    >
                        Exiting the game will mean you lose current progress
                    </Paragraph>
                    <Paragraph colorScheme="dark">Are you sure?</Paragraph>
                    <div className="game-settings__decision">
                        <div className="game-settings__decision-choice">
                            <Paragraph colorScheme="dark" withSpacing={false}>
                                No
                            </Paragraph>
                            <IconButton
                                onClick={() => setExitGameConfirmation(false)}
                                iconName="cross"
                                size="small"
                                type="decision"
                                altText="no"
                            />
                        </div>
                        <div className="game-settings__decision-choice">
                            <Paragraph colorScheme="dark" withSpacing={false}>
                                Yes
                            </Paragraph>
                            <IconButton
                                onClick={exitGame}
                                iconName="tick"
                                size="small"
                                type="decision"
                                altText="yes"
                            />
                        </div>
                    </div>
                </div>
            ) : (
                <>
                    {!shouldHideExitGame && (
                        <div className="settings-page__button">
                            <Paragraph colorScheme="dark" withSpacing={false}>
                                Exit Game
                            </Paragraph>
                            <IconButton
                                onClick={() =>
                                    previousPage !== QUICKPLAY_SCREEN
                                        ? setExitGameConfirmation(true)
                                        : exitGame()
                                }
                                iconName="exit"
                                withSpacing={true}
                                altText="exit game"
                            />
                        </div>
                    )}
                    <div className="settings-page__button">
                        <Paragraph colorScheme="dark" withSpacing={false}>
                            Resume
                        </Paragraph>
                        <IconButton
                            onClick={resumeGame}
                            iconName="arrow"
                            withSpacing={true}
                            altText="resume"
                        />
                    </div>
                    <div className="settings-page__button">
                        <Paragraph colorScheme="dark" withSpacing={false}>
                            Audio: {audio === true ? 'On' : 'Off'}
                        </Paragraph>
                        <IconButton
                            onClick={setAudio}
                            iconName={audio === true ? 'audio-on' : 'audio-off'}
                            withSpacing={true}
                            altText={audio === true ? 'audio-off' : 'audio-on'}
                        />
                    </div>
                </>
            )}
        </>
    );
};

export { GameSettings };
